import React, { Component } from 'react'
import { connect } from 'react-redux';
import { fetchPrinters, addNetworkPrinter, deletePrinters } from '../actions/printers';
import { CSVLink } from "react-csv"
import '../App.css';

import {ConfirmDialog, InputDeviceDialog, AddDevicesDialog} from '../utils/dialogs'
import {objectWitOnlyProperties, getCurrentSupplyLevel} from '../utils/utils'
import HardwareTableEx from '../controls/HardwareTableEx'
import LoadingControl from '../controls/Loading';
import DownloadButton from '../controls/DownloadButton';
import AddRemoveDevice from '../controls/AddDevice';

class HardwarePane extends Component {
  constructor(props) {
    super(props);
    this.state = {
      csvData: [],
      disableDelete: true
    };

    this.selection_ids = [];
  }

  componentDidMount() {
    this.props.fetchData();
  }

  getCVSData()
  {
      var raw_data = this.props.items;

      var cvs_data = [];

      var propertiesDevice = ['prnName', 'manufacturer', 'model', 'serialNumber', 'ip', 'supplies', 'pagesCount'];

      for (var i = 0; i < raw_data.length; i++)
      {
          var device = objectWitOnlyProperties(raw_data[i], propertiesDevice);

          if (device.supplies !== undefined)
          {
              for (var j = 0; j < device.supplies.length; j++)
              {
                  var value = {
                      level : device.supplies[j].level,
                      maxCapacity : device.supplies[j].maxCapacity,
                      color : device.supplies[j].color
                  };

                  var result = getCurrentSupplyLevel(value);

                  var supply = {
                      description: device.supplies[j].description,
                      currentLevel : result.current_level
                  }
                  cvs_data.push(Object.assign({}, device, supply));
              }
          }
          else
          {
              var empty_supply = {
                  description: "",
                  currentLevel : ""
              }
              cvs_data.push(Object.assign({}, device, empty_supply));
          }
      }

      cvs_data.map(item => {delete item.supplies; return item;});
      return cvs_data;
  }

  onCSVExportClick()
  {
    this.setState({ csvData: this.getCVSData() }, () => {
      // click the CSVLink component to trigger the CSV download
      this.csvLink.link.click()}
    );
  }

  onAddDevice()
  {
    this.addDevice.showModal();
  }

  addDeviceRequest(device)
  {
    this.props.addPrinter(device);
  }

  onLoadDevices(devices)
  {
    this.addDevices.showModal(devices);
  }

  onSelectionChanged(selected_keys)
  {
    this.selection_ids = selected_keys;
    this.setState( {disableDelete: selected_keys.length === 0 });
  }

  handleRemoveDevice()
  {
    if (this.selection_ids.length !== 0)
    {
      this.props.deletePrinters(this.selection_ids);
      this.onSelectionChanged([]);
    }
  }
  
  onRemoveDevice()
  {
    if (this.selection_ids.length > 0)
    {
      this.confirmDelete.showModal();    
    }
  }
    render() {  
        if(this.props.hasError != null)
        {
          return (
            <div><h3>{this.props.hasError.message}</h3></div>
          );
        }
        else if (this.props.isLoading)
        {
          return (
            <div><LoadingControl/></div>
          );
        }
        else
        {
          return (
            <div>
              <ConfirmDialog onOk = {() => {this.handleRemoveDevice()}} title="Dialog.confrim" content="Dialog.delete_objects" ref={(r)=>this.confirmDelete=r}/>
              <InputDeviceDialog onOk = {(e) => {this.addDeviceRequest(e)}} title="Dialog.add_device" content="Dialog.device_prompt" ref={(r)=>this.addDevice=r}/>
              <AddDevicesDialog title="Dialog.add_device" onOk = {() => {}} addRequest = {(device) => {this.addDeviceRequest(device)}} ref={(r)=>this.addDevices=r}/>
              <div className = "history-pane-header">
                <AddRemoveDevice disableDelete = {this.state.disableDelete} 
                    onAddDevice = {() => {this.onAddDevice()}}
                    onLoadDevices = {(devices) => {this.onLoadDevices(devices)}}
                    onRemove = {() => {this.onRemoveDevice()}}/>
                <CSVLink 
                  data={this.state.csvData}
                  separator=";"
                  ref={(r) => this.csvLink = r}
                  filename="devices_hardware.csv"
                  className="hidden"
                  target="_blank">                
                </CSVLink>
                <DownloadButton onCSVExport = {() => {this.onCSVExportClick()}}/>
                <HardwareTableEx data = {this.props.items} 
                onSelectChange = {(selected_keys) => this.onSelectionChanged(selected_keys)}/>
                </div>
            </div>  
          );
        }
      }
}

const mapStateToProps = (state) => {
  return {
      items: state.printers,
      hasError: state.printersHasError,
      isLoading: state.printersIsLoading,
  };
};     

const mapDispatchToProps = (dispatch) => {
return {
    fetchData: () => dispatch(fetchPrinters()),
    addPrinter: (device) => dispatch(addNetworkPrinter(device)),
    deletePrinters: (items_to_delete) => dispatch(deletePrinters(items_to_delete))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HardwarePane);